import {
  type EventPropsOf,
  SegmentActionName,
  SegmentObjectName,
  TrackingEventName,
  track,
  trackLegacyEvent,
} from '@heidi/analytics/events';
import { type GenerationMethod } from '@heidi/schema/ml-scribe';

import { type ExperimentProps, type NoteFailedErrorCode } from '../../contracts';

export function noteFailurePresented(
  props: EventPropsOf<TrackingEventName.NoteFailurePresented>
) {
  track({
    event_name: TrackingEventName.NoteFailurePresented,
    props,
    options: { amplitude: false },
  });
}

// Extracted from src/lib/analytics/scribe/general.ts; history: git log --follow src/lib/analytics/scribe/general.ts
export function noteGenerationEnd({
  sessionId,
  documentId,
  endTime,
  is_pinned_template,
  is_starter_pack_template,
}: {
  sessionId: string;
  documentId?: string;
  endTime: number;
  is_pinned_template: boolean;
  is_starter_pack_template: boolean;
}) {
  trackLegacyEvent({
    name: SegmentObjectName.General,
    props: {
      action: SegmentActionName.NoteGenerationEnd,
      sessionId,
      documentId,
      noteGenerationEndTime: endTime,
      is_pinned_template,
      is_starter_pack_template,
    },
  });
}

export function noteGenerationError({
  sessionId,
  error_code,
  documentId,
  is_pinned_template,
  is_starter_pack_template,
  generation_method,
}: {
  sessionId: string;
  error_code: NoteFailedErrorCode;
  documentId?: string;
  is_pinned_template?: boolean;
  is_starter_pack_template?: boolean;
  generation_method?: GenerationMethod | null;
}) {
  trackLegacyEvent({
    name: SegmentObjectName.General,
    props: {
      action: SegmentActionName.NoteGenerationError,
      sessionId,
      documentId,
    },
  });

  // V2: Amplitude + Datadog. Snowplow handler is still unwired
  // (`TODO(data)` in lib/snowplow/events/notes.ts). `error_code` is the
  // group-by; do not send free-text `error_message` (PHI).
  track({
    event_name: TrackingEventName.NoteFailed,
    props: {
      session_id: sessionId,
      document_id: documentId,
      error_code,
      is_pinned_template,
      is_starter_pack_template,
      generation_method,
    },
  });
}

// Moved from the app's note-generation wiring; payload and routing unchanged.
export function trackNoteCreated(
  props: ExperimentProps & {
    note_id: string;
    session_id: string;
    type: 'default' | 'alternate';
    template_id: string;
    time_to_first_token?: number;
    time_to_last_token?: number;
    section_count?: number;
    is_sectional?: boolean;
    is_regeneration?: boolean;
    device_file_name?: string;
  }
) {
  track({
    event_name: TrackingEventName.NoteCreated,
    props,
    options: { amplitude: false, posthog: true },
  });
}
